import React from 'react'
import Pagination from './Pagination';
import "./pagination.module.css"

const PaginationModule = ({ totalPages, postsPerPage, setPostsPerPage, currentPage, setCurrentPage }) => {
    return (
        <div className="mt-2 mx-0">
            <div className="flex justify-between items-center flex-wrap gap-4">
                <div className="border rounded px-2 text-md">
                    <label htmlFor="">Jump to</label>
                    <select
                        className='mx-2 focus:outline-none focus:ring-2 focus:ring-blue-400 pr-4'
                        style={{ width: "80px", height: "45px" }}
                        value={postsPerPage}
                        onChange={(e) => {
                            setPostsPerPage(parseInt(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={300}>300</option>
                        <option value={400}>400</option>
                        <option value={500}>500</option>
                    </select>
                    <span>Page {currentPage} of {totalPages}</span>
                </div>
                <div className=''>
                    <Pagination pages={totalPages} setCurrentPage={setCurrentPage} currentPage={currentPage} />
                </div>
            </div>
        </div>
    )
}

export default PaginationModule